import React from 'react'
import {Route, Switch} from 'react-router-dom'

import PageMaster from '../components/Page/PageMaster'
import {
  ProductDetail as AsyncProductDetail,
  ProductPageContainer as AsyncProductPageContainer,
} from '../components/Product/ProductMain'
import * as URLS from '../urls'
import ExternalRouteRedirect from './ExternalRouteRedirect'
import PrivateRoute from './PrivateRoute'
import ScrollToTop from './ScrollToTop'
import * as asyncRouteComponents from './asyncRouteComponents'

const PageRoutes = () => (
  <PageMaster>
    <ScrollToTop>
      <Switch>
        <Route path={URLS.ACCESSIBILITY} component={asyncRouteComponents.Accessibility} />
        <PrivateRoute path={URLS.ACCOUNT_EVENTS}>
          <asyncRouteComponents.AccountEvents />
        </PrivateRoute>
        <PrivateRoute path={URLS.ACCOUNT_INFO}>
          <asyncRouteComponents.AccountInfo />
        </PrivateRoute>
        <Route path={URLS.ONBOARDING} component={asyncRouteComponents.Onboarding} />
        <Route
          path={URLS.ACCOUNT_PASSWORD_RESET}
          component={asyncRouteComponents.AccountPasswordReset}
        />
        <Route path={URLS.ADD_REMOVE_ITEMS} component={asyncRouteComponents.AddRemoveItems} />
        <Route path={URLS.BLACK_DESK} component={asyncRouteComponents.BlackDesk} />
        <Route path={URLS.CAREERS} component={asyncRouteComponents.Careers} />
        <Route path={URLS.CANCEL_APPOINTMENT} component={asyncRouteComponents.CancelAppointment} />
        <Route path={URLS.DAVIDS_BRIDAL} component={asyncRouteComponents.DavidsBridal} />
        <PrivateRoute exact path={URLS.EVENT_PAGE}>
          <asyncRouteComponents.EventMgr />
        </PrivateRoute>
        <Route exact path={URLS.ORDER_DETAIL} component={asyncRouteComponents.OrderManager} />
        <Route
          exact
          path={URLS.CHECKOUT_ADD_ITEM}
          component={asyncRouteComponents.CheckoutAddItem}
        />
        <Route path={URLS.CATEGORY_PAGE} component={asyncRouteComponents.CategoryPage} />
        <Route path={URLS.REMOVE_ITEMS_PAGE} component={asyncRouteComponents.RemoveItemsPage} />
        <PrivateRoute path={URLS.ADDRESS_UPDATE}>
          <asyncRouteComponents.AddressUpdate />
        </PrivateRoute>
        <PrivateRoute path={URLS.ADDRESS_DETAILS}>
          <asyncRouteComponents.AddressDetails />
        </PrivateRoute>
        <PrivateRoute path={URLS.CART_ADD_ITEM}>
          <asyncRouteComponents.CartAddItem />
        </PrivateRoute>
        <Route path={URLS.STATIC_LOGIN} component={asyncRouteComponents.StaticLoginRedirect} />
        <Route
          path={URLS.STATIC_REGISTRATION}
          component={asyncRouteComponents.StaticRegistration}
        />
        <Route path={URLS.RESET_PASSWORD} component={asyncRouteComponents.StaticPasswordReset} />
        <Route path={URLS.EVENT_SUMMARY} component={asyncRouteComponents.EventSummary} />
        <Route path={URLS.FIT_LP} component={asyncRouteComponents.FitLp} />
        <Route path={URLS.FIT_BY_SLUG} component={asyncRouteComponents.FitPage} />
        <Route path={URLS.FIT} component={asyncRouteComponents.FitPage} />
        <Route path={URLS.FIT_GUARANTEE} component={asyncRouteComponents.FitGuarantee} />
        <Route path={URLS.GARBAGE_SUITS} component={asyncRouteComponents.GarbageSuits} />
        <Route path={URLS.HOW_IT_WORKS} component={asyncRouteComponents.Hiwp} />
        <Route exact path={URLS.HOME} component={asyncRouteComponents.Hp} />
        <Route path={URLS.HOME_TRY_ON} component={asyncRouteComponents.HomeTryOn} />
        <Route path={URLS.LEGAL} component={asyncRouteComponents.Legal} />
        <Route path={URLS.LOGOUT} component={asyncRouteComponents.Logout} />
        <Route path={URLS.LOOKBUILDER} component={asyncRouteComponents.LookbuilderMain} />
        <Route path={URLS.LOST_AND_FOUND} component={asyncRouteComponents.LostAndFound} />
        <Route path={URLS.SHOWROOMS} component={asyncRouteComponents.ShowroomsMain} />
        <Route path={URLS.ORDER_CONFIRMATION} component={asyncRouteComponents.OrderConfMain} />
        <Route path={URLS.OUR_QUALITY} component={asyncRouteComponents.OurQuality} />
        <Route path={URLS.OUR_STORY} component={asyncRouteComponents.OurStory} />
        <Route path={URLS.PROM} component={asyncRouteComponents.Promp} />
        <Route path={URLS.REAL_WEDDINGS} component={asyncRouteComponents.RealWeddings} />
        <PrivateRoute path={URLS.RECEIPT_EVENT}>
          <asyncRouteComponents.Receipt />
        </PrivateRoute>
        <Route path={URLS.RENTAL_AGREEMENT} component={asyncRouteComponents.RentalAgreement} />
        <Route path={URLS.RENTAL_EXTENSION} component={asyncRouteComponents.RentalExtension} />
        <Route path={URLS.RENT_TO_KEEP} component={asyncRouteComponents.RentToKeepTypeform} />
        <PrivateRoute path={URLS.NEW_RENT_TO_KEEP}>
          <asyncRouteComponents.RentToKeep />
        </PrivateRoute>
        <Route
          path={URLS.RENT_TO_KEEP_PRICING}
          component={asyncRouteComponents.RentToKeepPricing}
        />
        <PrivateRoute path={URLS.REPLACEMENTS}>
          <asyncRouteComponents.Replacements />
        </PrivateRoute>
        <Route path={URLS.RETURNS} component={asyncRouteComponents.Returns} />
        <Route path={URLS.RETURN_POLICY} component={asyncRouteComponents.ReturnPolicy} />
        <Route path={URLS.STYLED_LOOKS} component={asyncRouteComponents.StyledLooks} />
        <Route path={URLS.TUXEDO_SUIT_RENTAL} component={asyncRouteComponents.TuxedoSuitRental} />
        <Route path={URLS.WEDDINGS_LP} component={asyncRouteComponents.WeddingsLp} />
        <Route path={URLS.PRODUCT_REVIEWS} component={asyncRouteComponents.ProductReviews} />
        <ExternalRouteRedirect path={URLS.GROOMS_GUIDE} externalPath={URLS.AMAZON_GROOMS_GUIDE} />
        <PrivateRoute path={URLS.PRODUCT_CATEGORY_EMAIL}>
          <AsyncProductPageContainer />
        </PrivateRoute>
        <PrivateRoute path={URLS.PRODUCT_DETAIL_EMAIL}>
          <AsyncProductDetail />
        </PrivateRoute>
        <Route path={URLS.PRODUCT_DETAIL} component={asyncRouteComponents.ProductDetail} />
        <Route path={URLS.PRODUCT_CATEGORY} component={asyncRouteComponents.ProductMain} />
        <Route path={URLS.ADD_ITEMS_PRODUCT} component={asyncRouteComponents.ProductMain} />
        <Route path={URLS.OLD_PRODUCT_CATEGORY} component={asyncRouteComponents.OldProductMain} />
        <Route
          path={URLS.OLD_ADD_ITEMS_PRODUCT_CATEGORY}
          component={asyncRouteComponents.ProductMain}
        />
        <PrivateRoute path={URLS.CHECKOUT}>
          <asyncRouteComponents.Checkout />
        </PrivateRoute>
        <Route path={URLS.FEATURE_FLAGS} component={asyncRouteComponents.FeatureFlags} />
        <Route path="*" component={asyncRouteComponents.NotFound} />
      </Switch>
    </ScrollToTop>
  </PageMaster>
)

export default PageRoutes
